import { gridStyle } from "../styles";
import styled from "styled-components";

export const Grid = styled.div`
  ${gridStyle}
`;
